import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
import { numberToMillons } from 'src/utils/functions';

interface PropsAvanceMensualCanal {
  content: {
    data: any;
    header: { monthPrev: string; monthBest: string };
    resume: { facturacion: number; facturacionPrev: number; facturacionBest: number; porcPrevMonth: number; porcBestMonth: number; };
  };
}

const AvanceMensualCanal: FC<PropsAvanceMensualCanal> = ({
  content,
}) => {
  const title = 'Composición de Facturación Comparativo Mes Anterior y Mejor mes, En MM de PEN';
  return (
    <Box>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic>Canal</TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Facturación
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Mes anterior
                  <br />
                  {content.header.monthPrev}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Desfase mes Anterior
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Semaforo mes Anterior
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Mejor mes
                  <br />
                  {content.header.monthBest}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Desfase mejor mes
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableBody>
              {content.data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacion)}
                  </TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacionPrev)}
                  </TableCell>
                  <TableCell align="center">
                    {item.porcPrevMonth}
                    %
                  </TableCell>
                  <TableCell align="center">
                    <img
                      src={`/static/images/${item.semaforo}.png`}
                      alt={item.semaforo}
                    />
                  </TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacionBest)}
                  </TableCell>
                  <TableCell align="center">
                    {item.porcBestMonth}
                    %
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacion)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacionPrev)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  {content.resume.porcPrevMonth}
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" />
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacionBest)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  {content.resume.porcBestMonth}
                  %
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default AvanceMensualCanal;
